export default "__VITE_ASSET__Nu7tynQV__"